/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Organization_Not_Ready_For_BcInputs */

const en_error_organization_not_ready_for_bc = /** @type {(inputs: Error_Organization_Not_Ready_For_BcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The record cannot be sent to Business Central yet:`)
};

/**
* | output |
* | --- |
* | "The record cannot be sent to Business Central yet:" |
*
* @param {Error_Organization_Not_Ready_For_BcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_organization_not_ready_for_bc = /** @type {((inputs?: Error_Organization_Not_Ready_For_BcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Organization_Not_Ready_For_BcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_organization_not_ready_for_bc(inputs)
});